import React from 'react';
import {useDangerousHooks} from '@packages/systems/wfdl';
import Hitarea from '@packages/systems/design-system/Hitarea';
import {BaseButton as Button} from '@packages/systems/design-system/Button';
import {styled, styledDiv} from '@packages/utilities/styled';
import {TabNewIcon} from '@packages/systems/spring';
import {pixel} from '@packages/utilities/inline-style-utils';
import {
  useDispatch,
  useDesignerSelector,
} from '@packages/systems/designer/flux';

const selectGoogleMapsApiKey = (state: any) =>
  state.SiteDataStore.googleMapsApiKey;

export const MapApiKey = () => {
  const {useUnsafeActionCreators} = useDangerousHooks();
  const fluxDispatch = useDispatch();
  const {navigateToSiteIntegrations} =
    // eslint-disable-next-line react-hooks/react-compiler -- pre-ratchet baseline (BLOOP-3033)
    useUnsafeActionCreators().WidgetBridgeActionCreators;

  const hasValidKey = useDesignerSelector(selectGoogleMapsApiKey);
  const showKeyRequired = !hasValidKey;

  return (
    <div data-automation-id="googlemaps-apikey-container">
      <div>
        {showKeyRequired && (
          <>
            <APIRequiredText>Google Maps API Key Required</APIRequiredText>
            <MapApiKeyLabel>
              An API key is required to display Google Maps.
            </MapApiKeyLabel>
          </>
        )}
        <Hitarea>
          <ApiKeyButton
            data-automation-id="googlemaps-apikey-button"
            // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
            onClick={(e) => {
              fluxDispatch(navigateToSiteIntegrations(e));
            }}
          >
            <ButtonText>
              {showKeyRequired ? 'Add API Key' : 'Update API Key'}
              <TabNewIcon size={10} />
            </ButtonText>
          </ApiKeyButton>
        </Hitarea>
      </div>
      <Divider />
    </div>
  );
};

const MapApiKeyLabel = styled('p')(
  ({
    theme: {
      gutters,
      typography: {label},
    },
  }) => ({
    ...label,
    lineHeight: '14px',
    margin: `${gutters.x8}px 0px`,
  })
);

const APIRequiredText = styledDiv(
  ({
    theme: {
      typography: {copy, label},
    },
  }) => ({
    ...copy,
    lineHeight: pixel(label.lineHeight),
    fontWeight: 600,
  })
);

const ButtonText = styled('p')(({theme: {gutters}}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: gutters.base,
}));

const ApiKeyButton = styled(Button)(({theme: {gutters}}) => ({
  gap: gutters.base,
}));

const Divider = styledDiv(({theme}) => ({
  height: 1,
  backgroundColor: theme.colors.backgroundDeep,
  width: `calc(100% + ${theme.gutters.x8 * 2}px)`,
  marginLeft: -theme.gutters.x8,
  gridColumn: '1 / -1',
  marginBottom: `${theme.gutters.normal}px`,
  marginTop: `${theme.gutters.normal}px`,
}));
